import { render, staticRenderFns } from "./ManageCollectionsAccessModal.vue?vue&type=template&id=eb47a370&"
import script from "./ManageCollectionsAccessModal.vue?vue&type=script&lang=ts&"
export * from "./ManageCollectionsAccessModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports